var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_103_3",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_103_3",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACgUlEQVR4nO3dv4sTQRjG8RcLQbTxF7ZipQZBsFKw9D+wFBtBWwVRBIsTG6uzSWNtIV4nWHkgiIKIh3CyjYWFIDYWYicp/EogxR24ZNFc5pl5nw9Mf7Pf7Ew2e+xGmJmZFQQcBW4Bz4B3wEYDYy1qA+wFxsCE9nRRE+Aw8IF2dVELYDfwmrZ1UQvgOu3rogbALuAb7euiBsA5cuiiBsA1cuiiBsDdORP5DjxoYNyIGgArTXyyWuEgYhxEjIOIcRAxDiLGQZIFAfYDI+BMheM4sG9xR7tQkNkNrjHwlTZ8Au4DB3emwg4GAW4Cv2jTD+BiNUGAVdr3e/r7n3wQ4DJ5TICzskFm9+Iz3FPZ6q1ykEvkdFo1yGNyuqMa5A05PVIN0s37wyl/kfcvY33OvNZqDbISFZoecAcR4iBiHESMg4hxEDEOIiZtEOAQcHvZY8C80gYZUcCAeTnIMjlID58h2w+Gl6weXrKWrC+Eg+BNfeunwEtWj8xL1rESDxMYMK+cQVQ5iBgHEeMgYhxEjIOIcRAxDiImbRB8YSgXZEQBA+aV9gwZUcCAeTnIMjlID58h2w+Gl6weXrKWrC+Eg+BNXW3JOlLiKXM+QyqTdg9R5SBiHESMg4hxEDEOIqZUkKv/+2aaBVyH7CnxYADJIIvgn9/FOIgYBxHjIGIcRIyDiHEQMQ4ixheGYnw/RIyDiHEQMQ4ixkHEOIgYBxEDbM65kbNe4olxCxgf58zrSSgCXpDTw1CU5M06f3MlFAHnyWcy/Z/kUAW8JJdxKANOAj/J4TNwINQBFxJE+QKciFrMzpRXtPm6vKfS+8aAjX519pV4o9LxHngO3ANOlT6mZmYWqfwBzhVjhwLOJQQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsLight);
export default __webpack_public_path__ + "static/media/reports-light.f66440f9aa7a7d72a63887618426ab73.svg";
export { ForwardRef as ReactComponent };